import * as pbm from '@/grpc-gen/message_type_pb';
import ApiMessageType from '@/model/MessageType';

export default class MessageType extends ApiMessageType {
  static fromGrpcModel(o?: pbm.MessageType): MessageType {
    const messageType = new MessageType();

    messageType.id = Number(o?.id ?? 0);
    messageType.messageType = o?.type ?? '';

    return messageType;
  }
}
